/**
 * Created by zhengyf on 2017/9/26
 */

;(function() {
    angular
        .module('DSSXAPP')
        .component('region', {
            template:'<div class="aliIndex-region region-wrap c-b"><div class="left"><div class="rfq-title c-b"><h2 class="f-l"><a href="javascript:;">FIND SUPPLIERS BY REGION</a></h2><div class="label"></div></div><div class="row-content"><ul><li><img src="images/aliIndex/c1.png"> <span>India</span></li><li><img src="images/aliIndex/c2.png"> <span>Malaysia</span></li><li><img src="images/aliIndex/c3.png"> <span>Thailand</span></li><li><img src="images/aliIndex/c4.png"> <span>Indonesia</span></li><li><img src="images/aliIndex/c5.png"> <span>Vietnam</span></li><li><img src="images/aliIndex/c6.png"> <span>Turkey</span></li><li><img src="images/aliIndex/c7.png"> <span>South Korea</span></li><li class="d-p"><img src="images/aliIndex/c8.png"> <span>Japan</span></li><li class="d-p"><img src="images/aliIndex/c9.png"> <span>Pakistan</span></li><li><span class="more">More Regions</span></li></ul></div></div><div class="right"><div class="rfq-title c-b"><h2 class="f-l"><a href="javascript:;">OUR TRADE SERVICES</a></h2><div class="label"></div></div><div class="row-content"><ul><li class="right-item"><a href="javascript:;" class="item-1">Trade Assurance</a></li><li class="right-item"><a href="javascript:;" class="item-2">Business Identity</a></li><li class="right-item"><a href="javascript:;" class="item-3">Logistics Service</a></li><li class="right-item"><a href="javascript:;" class="item-4">Secure Payment</a></li><li class="right-item"><a href="javascript:;" class="item-5">Inspection Service</a></li></ul></div></div></div>',
            bindings: {

            },
            controllerAs: 'vm',
            controller: regionCtrl
        })

    function regionCtrl() {

    }

})();
